import { $win, $header, $hero, $wrapper } from './utils';

const scrolledHeader = () => {
	const scrollOffset = 100;

	$win.on('load scroll', function() {
		$wrapper.toggleClass('scrolled', $win.scrollTop() > scrollOffset);
	})
}

const solidHeader = () => {
	if ( $hero.length === 0 ) {
		$header.addClass('solid');
		$wrapper.addClass('no-hero');
	};
}

const navDropdown = () => {
	$('.nav ul ul').closest('li').addClass('has-dropdown');
}

const headerBar = () => {
	if ( $('.header-bar').length > 0 ) {
		$wrapper.addClass('has-header-bar');
	}
}

export default function headerUI() {
	scrolledHeader();

	navDropdown();

	solidHeader();

	headerBar();
}
